import { createBrowserRouter, Navigate } from "react-router-dom";

// layout
import DashboardLayout from "../layout/Dashboard";
import RequireAuth from 'components/RequireAuth';

// dashboard page
import Dashboard from "../pages/dashboard/default";

// auth
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";

// pricing
import MainPrice from "../pages/pricing/MainPrice";

// products
import AddProduct from "../pages/products/AddProduct";
import AddCategory from "../pages/products/AddCategory";
import CategorySubcategories from "../pages/products/CategorySubcategories";
import CategoryTags from "../pages/products/CategoryTags";
import ProductList from "../pages/products/ProductList";
import CustomProductPage from "../pages/products/CustomProductPage";

// other
import Wishlist from "../pages/Wishlist";
import Cart from "../pages/Cart";
import Users from "../pages/Users";
import CouponForm from "../pages/CouponForm";
import CouponList from "../pages/CouponList";
import NewsletterSubscribers from "../pages/NewsletterSubscribers";
import SaleForm from "../pages/SaleForm";
import SaleList from "../pages/SaleList";
import MediaLibrary from "../pages/MediaLibrary";
import MainPriceForm from "../pages/MainPriceForm"
import Tags from "../pages/Tags";
import PaymentsOrders from "../pages/payments/PaymentsOrders";
import PaymentOrderDetails from "../pages/payments/PaymentOrderDetails";
import BlogList from "../pages/blogs/BlogList";
import BlogForm from "../pages/blogs/BlogForm";
import EventsAnalytics from "../pages/analytics/EventsAnalytics";
import CustomProductsOverview from "../pages/custom-products/CustomProductsOverview";
import CustomProductsList from "../pages/custom-products/CustomProductsList";
import CustomProductPayments from "../pages/custom-products/CustomProductPayments";
import CustomProductPaymentDetails from "../pages/custom-products/CustomProductPaymentDetails";
import CustomProductInvoices from "../pages/custom-products/CustomProductInvoices";
import CustomProductInvoiceDetails from "../pages/custom-products/CustomProductInvoiceDetails";
import ProductReviews from "../pages/reviews/ProductReviews";
import RoleManagement from "../pages/roles/RoleManagement";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RequireAuth><DashboardLayout /></RequireAuth>,
    children: [
      { index: true, element: <Dashboard /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "roles", element: <RoleManagement /> },

      { path: "main-price", element: <MainPrice /> },

      { path: "AddProduct", element: <AddProduct /> },
      { path: "AddCategory", element: <AddCategory /> },
      { path: "categories/:categoryId/subcategories", element: <CategorySubcategories /> },
      { path: "categories/:categoryId/tags", element: <CategoryTags /> },
      { path: "ProductList", element: <ProductList /> },
      { path: "reviews", element: <ProductReviews /> },
      { path: "custom-product", element: <CustomProductPage /> },

      { path: "wishlist", element: <Wishlist /> },
      { path: "cart", element: <Cart /> },
      { path: "coupons", element: <CouponList /> },
      { path: "coupons/new", element: <CouponForm /> },
      { path: "coupons/:id/edit", element: <CouponForm /> },
      { path: "newsletter", element: <NewsletterSubscribers /> },
      { path: "CouponForm", element: <Navigate to="/coupons/new" replace /> },
      { path: "CouponList", element: <Navigate to="/coupons" replace /> },
      { path: "sales", element: <SaleList /> },
      { path: "sales/new", element: <SaleForm /> },
      { path: "sales/:id/edit", element: <SaleForm /> },
      { path: "SaleForm", element: <Navigate to="/sales/new" replace /> },
      { path: "SaleList", element: <Navigate to="/sales" replace /> },
      { path: "MediaLibrary", element: <MediaLibrary/> },
      { path: "MainPriceForm", element: <MainPriceForm/> },
      { path: "tags", element: <Tags /> },
      { path: "users", element: <Users /> },
      { path: "analytics/events", element: <EventsAnalytics /> },
      { path: "custom-products/overview", element: <CustomProductsOverview /> },
      { path: "custom-products/products", element: <CustomProductsList /> },
      { path: "custom-products/payments", element: <CustomProductPayments /> },
      { path: "custom-products/payments/:id", element: <CustomProductPaymentDetails /> },
      { path: "custom-products/invoices", element: <CustomProductInvoices /> },
      { path: "custom-products/invoices/:id", element: <CustomProductInvoiceDetails /> },
      { path: "payments/orders", element: <PaymentsOrders /> },
      { path: "payments/orders/:id", element: <PaymentOrderDetails /> },
      { path: "blogs", element: <BlogList /> },
      { path: "blogs/new", element: <BlogForm /> },
      { path: "blogs/:id/edit", element: <BlogForm /> },
    ]
  },

  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> }
]);

export default router;
